import { InputAttributeProps } from 'Types/Attribute.types'
import { Input } from 'antd/lib'
import React, { useCallback } from 'react'
import './Input.less'

const InputAttribute: React.FC<InputAttributeProps> = props => {
    const handleChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            props.onChange(e.target.value)
        },
        [props]
    )

    return (
        <div
            className={`attribute-main ${props.className}`}
            style={{ width: props.width ?? '90%' }}
            data-testid="input-wrapper"
        >
            <span className="attribute-main-title">{props.label}</span>
            <Input
                placeholder={props.placeholder ?? 'Please enter value'}
                value={props.value}
                onChange={handleChange}
                allowClear
                disabled={props.readonly}
            />
        </div>
    )
}

export default InputAttribute
